import React from 'react'
import BlogTemplate from './components/blog-template'
import { useEffect } from 'react'

export default function BlogHome({ location }) {
	return (
		<BlogTemplate location={location} description='Blog posts by Gino Valente' url='/blog' />
	)
}
